import * as types from '../const/action.types';

export function typemachine(state = {}, action) {
    switch (action.type) {
        case types.LOAD_TYPE_MACHINE_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function typemachines(state = [], action) {
    switch (action.type) {
        case types.TYPE_MACHINES_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function typemachinesHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.TYPE_MACHINES_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function typemachinesIsLoading(state = false, action) {
    switch (action.type) {
        case types.TYPE_MACHINES_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/type.machine.reducer.js